var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_4367)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 51.5C56.1698 51.5013 54.8776 51.9437 53.8258 52.758C52.7739 53.5723 52.0219 54.7125 51.6875 56H33.5C31.9087 56 30.3826 55.3679 29.2574 54.2426C28.1321 53.1174 27.5 51.5913 27.5 50C27.5 48.4087 28.1321 46.8826 29.2574 45.7574C30.3826 44.6321 31.9087 44 33.5 44H51.5C53.4891 44 55.3968 43.2098 56.8033 41.8033C58.2098 40.3968 59 38.4891 59 36.5C59 34.5109 58.2098 32.6032 56.8033 31.1967C55.3968 29.7902 53.4891 29 51.5 29H33.5C33.1022 29 32.7206 29.158 32.4393 29.4393C32.158 29.7206 32 30.1022 32 30.5C32 30.8978 32.158 31.2794 32.4393 31.5607C32.7206 31.842 33.1022 32 33.5 32H51.5C52.6935 32 53.8381 32.4741 54.682 33.318C55.5259 34.1619 56 35.3065 56 36.5C56 37.6935 55.5259 38.8381 54.682 39.682C53.8381 40.5259 52.6935 41 51.5 41H33.5C31.1131 41 28.8239 41.9482 27.136 43.636C25.4482 45.3239 24.5 47.6131 24.5 50C24.5 52.3869 25.4482 54.6761 27.136 56.364C28.8239 58.0518 31.1131 59 33.5 59H51.6875C51.968 60.0864 52.5476 61.0725 53.3603 61.8461C54.1731 62.6197 55.1865 63.1498 56.2855 63.3764C57.3844 63.603 58.5249 63.5168 59.5774 63.1278C60.6298 62.7387 61.5521 62.0623 62.2395 61.1754C62.9268 60.2885 63.3517 59.2267 63.4658 58.1104C63.58 56.9941 63.3788 55.8683 62.8852 54.8606C62.3916 53.8529 61.6254 53.0038 60.6734 52.4098C59.7215 51.8158 58.6221 51.5006 57.5 51.5ZM57.5 60.5C56.9067 60.5 56.3266 60.3241 55.8333 59.9944C55.3399 59.6648 54.9554 59.1962 54.7284 58.6481C54.5013 58.0999 54.4419 57.4967 54.5576 56.9147C54.6734 56.3328 54.9591 55.7982 55.3787 55.3787C55.7982 54.9591 56.3328 54.6734 56.9147 54.5576C57.4967 54.4419 58.0999 54.5013 58.6481 54.7284C59.1962 54.9554 59.6648 55.3399 59.9944 55.8333C60.3241 56.3266 60.5 56.9067 60.5 57.5C60.5 58.2956 60.1839 59.0587 59.6213 59.6213C59.0587 60.1839 58.2957 60.5 57.5 60.5Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_4367",
    x1: 0,
    y1: 45,
    x2: 90,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4);
export default __webpack_public_path__ + "static/media/c-4.076b82abe8d8ccf2f477744c7881e9ed.svg";
export { ForwardRef as ReactComponent };